import { useLoaderData, useNavigate } from 'react-router-dom'
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Icon,
  CardActionArea,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import {
  People,
  AccountBox,
  FactCheck,
  Subscriptions,
} from '@mui/icons-material'
import React from 'react'

// Define the type for the loader data
type DashboardStats = {
  userCount: number
  profileCount: number
  licenseCount: number
  subscriptionCount: number
}

// Reusable Stat Card Component
interface StatCardProps {
  title: string
  value: number | string
  icon: React.ReactElement
  color: string
  path: string
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color,
  path,
}) => {
  const navigate = useNavigate()
  return (
    <Card sx={{ backgroundColor: color, color: 'white' }}>
      <CardActionArea onClick={() => navigate(path)}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Icon sx={{ mr: 1.5, fontSize: '2rem' }}>{icon}</Icon>
            <Typography variant="h6" component="div">
              {title}
            </Typography>
          </Box>
          <Typography
            variant="h3"
            component="div"
            sx={{ textAlign: 'right', fontWeight: 'bold' }}
          >
            {value}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default function Dashboard() {
  const stats = useLoaderData() as DashboardStats

  return (
    <PageAppBar pageName="Dashboard">
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Utilisateurs"
              value={stats.userCount}
              icon={<People />}
              color="primary.dark"
              path="/users"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Profils"
              value={stats.profileCount}
              icon={<AccountBox />}
              color="secondary.dark"
              path="/profiles"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Licences"
              value={stats.licenseCount}
              icon={<FactCheck />}
              color="success.dark"
              path="/licenses"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              title="Abonnements"
              value={stats.subscriptionCount}
              icon={<Subscriptions />}
              color="#B83737"
              path="/subscriptions"
            />
          </Grid>
        </Grid>
      </Box>
    </PageAppBar>
  )
}
